/* lua.js generated code undefined */

/*     辅助正交分组测试，检查用户标签的工具类
    所有的查询方法都要以"getUserTag_"为前缀，详见: function OrthStrategyHelper:checkStrategy
 */
const Event = require("cocos/framework/components/event")
OrthUserTagHelper = xClass("OrthUserTagHelper", Event)
let _instance = null
OrthUserTagHelper.getInstance = function () {
    let self = this
    if (!_instance) {
        _instance = OrthUserTagHelper.new()
    }
    return _instance
}
OrthUserTagHelper.prototype.ctor = function () { }
/*     @desc: 用户近x日（不算今天，往前x天）的活跃天数，单位为天
    --@interval: 近x日（不算今天，往前x天）
    @return: 活跃天数
 */
OrthUserTagHelper.prototype.getActiveDay = function (interval) {
    let self = this
    if (UserTagData.getInstance().userLabelData){
        return UserTagData.getInstance().userLabelData.loginNum;
    }
    return 0;
    // let tagData = UserManager.getInstance().getUserTagData()
    // let dayActives = tagData.dayActives
    // if (dayActives) {
    //     // 计算去重活跃天数
    //     let activeDays = 0
    //     let dayChecked = table()
    //     let todayStart = Localhost.getTodayStart()
    //     for (let i = 1, loginStamp = dayActives[1]; loginStamp; i++, loginStamp = dayActives[i]) {
    //         cc.log("-- " + os.date("%Y-%m-%d %H:%M %S", loginStamp))
    //         let dayStart = Localhost.getDayStartTimeByTS(loginStamp)
    //         if (!dayChecked[dayStart]) {
    //             dayChecked[dayStart] = true
    //             let loginDay = Localhost.timeInDay(todayStart - dayStart)
    //             if (loginDay > 0 && loginDay <= interval) {
    //                 activeDays = activeDays + 1
    //             }
    //         }
    //     }
    //     return activeDays
    // }
    // return 0
}
/*     @desc: 查用户是否是在近x日（不包含今天，往前算x天）内新增
    --@interval: 近x日（不包含今天，往前算x天）
    @return: ，0:否 1:是
 */
OrthUserTagHelper.prototype.isNewUserInDay = function (interval) {
    let self = this
    if (UserTagData.getInstance().userLabelData){
        return UserTagData.getInstance().userLabelData.newUser;
    }
    return 0;
    // let registerTime = UserManager.getInstance().getCreateTimeInSec()
    // let registerDayStart = Localhost.getDayStartTimeByTS(registerTime)
    // let todayStart = Localhost.getTodayStart()
    // let delta = Localhost.timeInDay(todayStart - registerDayStart, false)
    // if (delta <= interval && delta > 0) {
    //     return 1
    // }
    // return 0
}
/*     @desc: 近x日（不包含今天）付费额，单位为元
    --@interval: 近x日（不包含今天）
    @return: 付费额，单位为元
 */
OrthUserTagHelper.prototype.getPaymentInDay = function (interval) {
    let self = this
    if (UserTagData.getInstance().userLabelData){
        return UserTagData.getInstance().userLabelData.payNum;
    }
    return 0;
    // let tagData = UserManager.getInstance().getUserTagData()
    // let cashLogs = tagData.cashLogs
    // let dayStart = Localhost.getTodayStart()
    // let dayInSec = 86400
    // let [first, last] = [(dayStart - dayInSec * interval) * 1000, dayStart * 1000]
    // let payment = 0
    // table.each(cashLogs, function (v) {
    //     if (v.time >= first && v.time < last) {
    //         if (v.totalPrice === null) {
    //             v.totalPrice = (v.num || 1) * (v.price || 0)
    //         }
    //         payment = payment + v.totalPrice
    //     }
    // })
    // payment = payment / 100
    // return payment
}
//----------------------------------------------------------------------------------------------------------
// 以下所有的查询方法都要以"getUserTag_"为前缀，详见: function OrthStrategyHelper:checkStrategy
// 用户近7日（不包含今天，往前算7天）活跃天数，单位为天，取值为0~7
OrthUserTagHelper.prototype.getUserTag_Active7DayTag = function () {
    let self = this
    let days = OrthUserTagHelper.getInstance().getActiveDay(7)
    if (!$null(OrthGroupHelper.getInstance()._active7Day)) {
        days = OrthGroupHelper.getInstance()._active7Day
        console.log("强制使用【active7Day】" + days)
        // QAGUILogger.getInstance().print("强制使用【active7Day】" + days, "orth")
    }
    return days
}
// 查用户是否是在近7日（不包含今天，往前算7天）内新增，0否1是
OrthUserTagHelper.prototype.getUserTag_NewUser7DayTag = function () {
    let self = this
    let isNew = OrthUserTagHelper.getInstance().isNewUserInDay(7)
    if (!$null(OrthGroupHelper.getInstance()._newUser7Day)) {
        isNew = OrthGroupHelper.getInstance()._newUser7Day
        console.log("强制使用【newUser7Day】" + isNew)
        // QAGUILogger.getInstance().print("强制使用【newUser7Day】" + isNew, "orth")
    }
    return isNew
}
// 28日（4周，类似月指标，不包含今天）付费额，单位为元
OrthUserTagHelper.prototype.getUserTag_Payment28DayTag = function () {
    let self = this
    let payment = OrthUserTagHelper.getInstance().getPaymentInDay(28)
    if (!$null(OrthGroupHelper.getInstance()._payment28Day)) {
        payment = OrthGroupHelper.getInstance()._payment28Day
        console.log("强制使用【payment28Day】" + payment)
        // QAGUILogger.getInstance().print("强制使用【payment28Day】" + payment, "orth")
    }
    return payment
}
// 用户实时主线最高关卡进度
OrthUserTagHelper.prototype.getUserTag_LevelAreaRealTimeTag = function () {
    let self = this
    let topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    if (!$null(OrthGroupHelper.getInstance()._levelAreaRealTime)) {
        topLevel = OrthGroupHelper.getInstance()._levelAreaRealTime
        console.log("强制使用【levelAreaRealTime】" + topLevel)
        // QAGUILogger.getInstance().print("强制使用【levelAreaRealTime】" + topLevel, "orth")
    }
    return topLevel
}
//----------------------------------------------------------------------------------------------------------
